// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studio-content {
  min-height: 100vh;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.studio-main {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: clamp(100px, 18vh, 180px) clamp(20px, 5vw, 32px) 60px;
  text-align: center;
  position: relative;
  z-index: 5;
}

.studio-title {
  margin: 0 0 clamp(16px, 3vh, 24px) 0;
  font-size: clamp(36px, 4.5vw, 52px);
  font-weight: 400;
  line-height: 1.1;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.studio-title-em {
  font-style: italic;
}

.studio-subtitle {
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: clamp(13px, 1.4vw, 15px);
  line-height: 1.65;
  color: var(--color-text-secondary);
  max-width: 480px;
  margin: 0 auto clamp(24px, 4vh, 36px);
}

/* ── Upload Panel ── */

.studio-upload-panel {
  background: var(--color-bg-canvas-surface);
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  position: relative;
  overflow: hidden;
}

.studio-upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 32px;
  gap: 20px;
}

.studio-upload-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.studio-upload-label {
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text-primary);
}

.studio-upload-hint {
  font-size: 12px;
  color: var(--color-text-secondary);
}

.studio-upload-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.studio-btn-upload {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.studio-btn-upload:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.studio-btn-upload:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.studio-btn-upload svg {
  width: 15px;
  height: 15px;
}

.studio-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: studio-spin 0.6s linear infinite;
}

@keyframes studio-spin {
  to { transform: rotate(360deg); }
}

.studio-submit-error {
  display: block;
  margin-top: 8px;
  color: #ef4444;
  font-size: 12px;
  text-align: center;
}

.studio-btn-record {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.15s ease;
}

.studio-btn-record:hover {
  background: var(--color-bg-user-bubble);
}

.studio-btn-record svg {
  width: 14px;
  height: 14px;
}

.studio-record-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #dc2626;
  flex-shrink: 0;
}

.studio-upload-formats {
  font-size: 11px;
  color: var(--color-text-secondary);
  opacity: 0.7;
  margin-top: 4px;
}

/* ── Panel Divider ── */

.studio-panel-divider {
  height: 1px;
  background: var(--color-border-input);
}

/* ── In-panel Style Presets ── */

.studio-panel-presets {
  padding: 16px 20px 20px;
}

.studio-panel-presets-label {
  display: inline-block;
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-text-secondary);
  margin-bottom: 10px;
}

.studio-presets-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  background: var(--color-border-input);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  overflow: hidden;
}

.studio-preset-card {
  background: var(--color-bg-canvas-surface);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.studio-preset-card:hover {
  background: var(--color-bg-root);
}

.studio-preset-card--selected {
  background: var(--color-bg-root);
}

.studio-preset-swatch {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.studio-preset-check {
  width: 16px;
  height: 16px;
  color: var(--color-bg-canvas-surface);
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.3));
}

.studio-preset-swatch--apple .studio-preset-check {
  color: var(--color-text-primary);
}

.studio-preset-swatch--apple {
  background: var(--color-bg-input);
}

.studio-preset-swatch--custom {
  background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);
  border-color: transparent;
}

.studio-preset-swatch--custom .studio-preset-check {
  color: #fff;
}

.studio-preset-swatch--podcast {
  background: #d4a574;
}

.studio-preset-swatch--youtube {
  background: var(--color-bg-canvas-frame);
}

.studio-preset-swatch--youtube .studio-preset-check {
  color: var(--color-text-primary);
}

.studio-custom-prompt {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease;
  box-sizing: border-box;
}

.studio-custom-prompt::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.studio-custom-prompt:focus {
  border-color: var(--color-text-primary);
}

.studio-preset-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.studio-preset-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1.2;
}

.studio-preset-desc {
  font-size: 11px;
  color: var(--color-text-secondary);
}

/* ── How it Works ── */

.studio-how {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 64px clamp(20px, 5vw, 32px) 0;
  text-align: center;
}

.studio-how-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(24px, 3vw, 32px);
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 32px;
}

.studio-how-title em {
  font-style: italic;
  color: var(--color-accent-base);
}

.studio-steps {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: var(--color-border-input);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
}

.studio-step {
  background: var(--color-bg-canvas-surface);
  padding: 28px 20px;
  text-align: center;
  transition: background 0.15s ease;
}

.studio-step:hover {
  background: var(--color-bg-root);
}

.studio-step-number {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 28px;
  font-weight: 400;
  color: var(--color-text-primary);
  opacity: 0.12;
  line-height: 1;
  margin-bottom: 14px;
}

.studio-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: var(--color-bg-root);
  border: 1px solid var(--color-border-input);
  color: var(--color-accent-base);
  margin: 0 auto 12px;
}

.studio-step-icon svg {
  width: 20px;
  height: 20px;
}

.studio-step-title {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: 18px;
  font-weight: 400;
  color: var(--color-text-primary);
  margin: 0 0 4px;
}

.studio-step-desc {
  font-size: 12px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  margin: 0;
}

/* ── Recorded Preview ── */

.studio-recorded-preview {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.studio-recorded-video {
  width: 100%;
  display: block;
  background: var(--color-bg-input);
  max-height: 340px;
  object-fit: contain;
}

.studio-recorded-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 20px;
  border-top: 1px solid var(--color-border-input);
}

/* ── Recording Modal ── */

.studio-rec-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  animation: studioRecFadeIn 0.2s ease;
}

@keyframes studioRecFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.studio-rec-modal {
  width: min(640px, 100%);
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: studioRecSlideIn 0.25s ease;
}

@keyframes studioRecSlideIn {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

.studio-rec-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.studio-rec-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-primary);
}

.studio-rec-close {
  width: 28px;
  height: 28px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  border-radius: 4px;
  color: var(--color-text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, color 0.15s ease;
}

.studio-rec-close:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.studio-rec-close svg {
  width: 16px;
  height: 16px;
}

.studio-rec-viewport {
  position: relative;
  background: #000;
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.studio-rec-live {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.studio-rec-live--mirrored {
  transform: scaleX(-1);
}

.studio-rec-review-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #000;
}

.studio-rec-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 500;
}

.studio-rec-error {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  text-align: center;
  line-height: 1.5;
}

.studio-rec-indicator {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.studio-rec-indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #dc2626;
  animation: studioRecPulse 1s ease-in-out infinite;
}

@keyframes studioRecPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.studio-rec-indicator-time {
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.studio-rec-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 16px;
  border-top: 1px solid var(--color-border-input);
}

.studio-rec-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid var(--color-border-input);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.studio-rec-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.studio-rec-btn--secondary {
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
}

.studio-rec-btn--secondary:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.studio-rec-btn--primary {
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.studio-rec-btn--primary:hover:not(:disabled) {
  opacity: 0.88;
}

.studio-rec-btn--record {
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
}

.studio-rec-btn--record:hover:not(:disabled) {
  opacity: 0.88;
}

.studio-rec-btn--stop {
  background: #dc2626;
  color: #fff;
  border-color: #dc2626;
}

.studio-rec-btn--stop:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

.studio-rec-btn--icon {
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
}

.studio-rec-btn--icon:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.studio-rec-btn--icon svg {
  width: 18px;
  height: 18px;
}

.studio-rec-btn-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #dc2626;
  flex-shrink: 0;
}

.studio-rec-btn-square {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: #fff;
  flex-shrink: 0;
}

@media (max-width: 720px) {
  .studio-rec-backdrop {
    padding: 16px;
  }

  .studio-rec-modal {
    width: 100%;
  }
}

/* ── Footer ── */

.studio-footer {
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  padding: 40px clamp(20px, 5vw, 32px) 80px;
  text-align: center;
  font-size: 12px;
  color: var(--color-text-secondary);
  opacity: 0.6;
}

/* ── Responsive ── */

@media (max-width: 720px) {
  .studio-main {
    gap: 24px;
  }

  .studio-title {
    margin-top: 6vh;
  }

  .studio-upload-zone {
    padding: 28px 20px;
  }

  .studio-upload-actions {
    flex-direction: column;
    width: 100%;
  }

  .studio-btn-upload,
  .studio-btn-record {
    width: 100%;
    justify-content: center;
  }

  .studio-presets-grid {
    grid-template-columns: 1fr;
  }

  .studio-steps {
    grid-template-columns: 1fr;
  }

  .studio-footer {
    padding-bottom: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/StudioPage.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;EAC9E,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kEAAkE;EAClE,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,uBAAuB;;AAEvB;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA,iCAAiC;;AAEjC;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;AACX;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA,0BAA0B;;AAE1B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,kEAAkE;EAClE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iBAAiB;;AAEjB;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.studio-content {\n  min-height: 100vh;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.studio-main {\n  max-width: 720px;\n  width: 100%;\n  margin: 0 auto;\n  padding: clamp(100px, 18vh, 180px) clamp(20px, 5vw, 32px) 60px;\n  text-align: center;\n  position: relative;\n  z-index: 5;\n}\n\n.studio-title {\n  margin: 0 0 clamp(16px, 3vh, 24px) 0;\n  font-size: clamp(36px, 4.5vw, 52px);\n  font-weight: 400;\n  line-height: 1.1;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.studio-title-em {\n  font-style: italic;\n}\n\n.studio-subtitle {\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: clamp(13px, 1.4vw, 15px);\n  line-height: 1.65;\n  color: var(--color-text-secondary);\n  max-width: 480px;\n  margin: 0 auto clamp(24px, 4vh, 36px);\n}\n\n/* ── Upload Panel ── */\n\n.studio-upload-panel {\n  background: var(--color-bg-canvas-surface);\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  position: relative;\n  overflow: hidden;\n}\n\n.studio-upload-zone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 32px;\n  gap: 20px;\n}\n\n.studio-upload-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.studio-upload-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n}\n\n.studio-upload-hint {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n.studio-upload-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.studio-btn-upload {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.studio-btn-upload:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.studio-btn-upload:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.studio-btn-upload svg {\n  width: 15px;\n  height: 15px;\n}\n\n.studio-btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: studio-spin 0.6s linear infinite;\n}\n\n@keyframes studio-spin {\n  to { transform: rotate(360deg); }\n}\n\n.studio-submit-error {\n  display: block;\n  margin-top: 8px;\n  color: #ef4444;\n  font-size: 12px;\n  text-align: center;\n}\n\n.studio-btn-record {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.studio-btn-record:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.studio-btn-record svg {\n  width: 14px;\n  height: 14px;\n}\n\n.studio-record-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #dc2626;\n  flex-shrink: 0;\n}\n\n.studio-upload-formats {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n  margin-top: 4px;\n}\n\n/* ── Panel Divider ── */\n\n.studio-panel-divider {\n  height: 1px;\n  background: var(--color-border-input);\n}\n\n/* ── In-panel Style Presets ── */\n\n.studio-panel-presets {\n  padding: 16px 20px 20px;\n}\n\n.studio-panel-presets-label {\n  display: inline-block;\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--color-text-secondary);\n  margin-bottom: 10px;\n}\n\n.studio-presets-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1px;\n  background: var(--color-border-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.studio-preset-card {\n  background: var(--color-bg-canvas-surface);\n  padding: 12px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.studio-preset-card:hover {\n  background: var(--color-bg-root);\n}\n\n.studio-preset-card--selected {\n  background: var(--color-bg-root);\n}\n\n.studio-preset-swatch {\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.studio-preset-check {\n  width: 16px;\n  height: 16px;\n  color: var(--color-bg-canvas-surface);\n  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.3));\n}\n\n.studio-preset-swatch--apple .studio-preset-check {\n  color: var(--color-text-primary);\n}\n\n.studio-preset-swatch--apple {\n  background: var(--color-bg-input);\n}\n\n.studio-preset-swatch--custom {\n  background: linear-gradient(135deg, #6366f1, #a855f7, #ec4899);\n  border-color: transparent;\n}\n\n.studio-preset-swatch--custom .studio-preset-check {\n  color: #fff;\n}\n\n.studio-preset-swatch--podcast {\n  background: #d4a574;\n}\n\n.studio-preset-swatch--youtube {\n  background: var(--color-bg-canvas-frame);\n}\n\n.studio-preset-swatch--youtube .studio-preset-check {\n  color: var(--color-text-primary);\n}\n\n.studio-custom-prompt {\n  display: block;\n  width: 100%;\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  line-height: 1.5;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.15s ease;\n  box-sizing: border-box;\n}\n\n.studio-custom-prompt::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.studio-custom-prompt:focus {\n  border-color: var(--color-text-primary);\n}\n\n.studio-preset-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.studio-preset-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1.2;\n}\n\n.studio-preset-desc {\n  font-size: 11px;\n  color: var(--color-text-secondary);\n}\n\n/* ── How it Works ── */\n\n.studio-how {\n  max-width: 720px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 64px clamp(20px, 5vw, 32px) 0;\n  text-align: center;\n}\n\n.studio-how-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(24px, 3vw, 32px);\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 32px;\n}\n\n.studio-how-title em {\n  font-style: italic;\n  color: var(--color-accent-base);\n}\n\n.studio-steps {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1px;\n  background: var(--color-border-input);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.studio-step {\n  background: var(--color-bg-canvas-surface);\n  padding: 28px 20px;\n  text-align: center;\n  transition: background 0.15s ease;\n}\n\n.studio-step:hover {\n  background: var(--color-bg-root);\n}\n\n.studio-step-number {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 28px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  opacity: 0.12;\n  line-height: 1;\n  margin-bottom: 14px;\n}\n\n.studio-step-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  background: var(--color-bg-root);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-accent-base);\n  margin: 0 auto 12px;\n}\n\n.studio-step-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.studio-step-title {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: 18px;\n  font-weight: 400;\n  color: var(--color-text-primary);\n  margin: 0 0 4px;\n}\n\n.studio-step-desc {\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  margin: 0;\n}\n\n/* ── Recorded Preview ── */\n\n.studio-recorded-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.studio-recorded-video {\n  width: 100%;\n  display: block;\n  background: var(--color-bg-input);\n  max-height: 340px;\n  object-fit: contain;\n}\n\n.studio-recorded-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px 20px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n/* ── Recording Modal ── */\n\n.studio-rec-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  animation: studioRecFadeIn 0.2s ease;\n}\n\n@keyframes studioRecFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.studio-rec-modal {\n  width: min(640px, 100%);\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: studioRecSlideIn 0.25s ease;\n}\n\n@keyframes studioRecSlideIn {\n  from { opacity: 0; transform: translateY(16px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.studio-rec-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.studio-rec-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.studio-rec-close {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  border-radius: 4px;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.studio-rec-close:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.studio-rec-close svg {\n  width: 16px;\n  height: 16px;\n}\n\n.studio-rec-viewport {\n  position: relative;\n  background: #000;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n}\n\n.studio-rec-live {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.studio-rec-live--mirrored {\n  transform: scaleX(-1);\n}\n\n.studio-rec-review-video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  background: #000;\n}\n\n.studio-rec-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.studio-rec-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 13px;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.studio-rec-indicator {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n}\n\n.studio-rec-indicator-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #dc2626;\n  animation: studioRecPulse 1s ease-in-out infinite;\n}\n\n@keyframes studioRecPulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n.studio-rec-indicator-time {\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  font-variant-numeric: tabular-nums;\n}\n\n.studio-rec-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 16px;\n  border-top: 1px solid var(--color-border-input);\n}\n\n.studio-rec-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 4px;\n  border: 1px solid var(--color-border-input);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n\n.studio-rec-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.studio-rec-btn--secondary {\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n}\n\n.studio-rec-btn--secondary:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.studio-rec-btn--primary {\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.studio-rec-btn--primary:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.studio-rec-btn--record {\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n}\n\n.studio-rec-btn--record:hover:not(:disabled) {\n  opacity: 0.88;\n}\n\n.studio-rec-btn--stop {\n  background: #dc2626;\n  color: #fff;\n  border-color: #dc2626;\n}\n\n.studio-rec-btn--stop:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.studio-rec-btn--icon {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n}\n\n.studio-rec-btn--icon:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.studio-rec-btn--icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.studio-rec-btn-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: #dc2626;\n  flex-shrink: 0;\n}\n\n.studio-rec-btn-square {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n@media (max-width: 720px) {\n  .studio-rec-backdrop {\n    padding: 16px;\n  }\n\n  .studio-rec-modal {\n    width: 100%;\n  }\n}\n\n/* ── Footer ── */\n\n.studio-footer {\n  max-width: 720px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 40px clamp(20px, 5vw, 32px) 80px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 720px) {\n  .studio-main {\n    gap: 24px;\n  }\n\n  .studio-title {\n    margin-top: 6vh;\n  }\n\n  .studio-upload-zone {\n    padding: 28px 20px;\n  }\n\n  .studio-upload-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .studio-btn-upload,\n  .studio-btn-record {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .studio-presets-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .studio-steps {\n    grid-template-columns: 1fr;\n  }\n\n  .studio-footer {\n    padding-bottom: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
